import { useState } from 'react';
import CheckOutlined from '@mui/icons-material/CheckOutlined';
import { DatePicker } from '@practium/ui';
import styles from './CreatedAtUntilPanel.module.css';

interface CreatedAtUntilPanelProps {
	value: string;
	onChange: (value: string) => void;
	onClose: () => void;
}

export const CreatedAtUntilPanel = ({ value, onChange, onClose }: CreatedAtUntilPanelProps) => {
	const [localDate, setLocalDate] = useState(value);

	const handleApply = () => {
		onChange(localDate);
		onClose();
	};

	return (
		<>
			<div className={styles.header}>
				<span className={styles.title}>Criado até</span>
			</div>
			<div className={styles.field}>
				<span className={styles.label}>Até</span>
				<DatePicker value={localDate} onChange={setLocalDate} placeholder="DD/MM/AAAA" />
			</div>
			<button
				type="button"
				className={styles.applyBtn}
				onClick={handleApply}
				disabled={!localDate}
			>
				<CheckOutlined className={styles.applyIcon} />
				Aplicar
			</button>
		</>
	);
};
